import { render, staticRenderFns } from "./SurveyComponent.vue?vue&type=template&id=07bfc7aa&scoped=true"
import script from "./SurveyComponent.vue?vue&type=script&lang=js"
export * from "./SurveyComponent.vue?vue&type=script&lang=js"
import style0 from "./SurveyComponent.vue?vue&type=style&index=0&id=07bfc7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bfc7aa",
  null
  
)

export default component.exports